import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollToPlugin, ScrollSmoother);

export function smoothScrollToTop(duration = 0.55) {
  if (typeof window === "undefined") {
    return;
  }

  const smoother = ScrollSmoother.get();

  if (smoother) {
    smoother.scrollTo(0, true);
    return;
  }

  gsap.killTweensOf(window);
  gsap.to(window, {
    duration,
    ease: "power2.out",
    scrollTo: { y: 0, autoKill: false },
  });
}
